import React from 'react';
import "../css/newsletter.scss"
import fbIcon from "../imgs/fb.png"
import whatsappIcon from '../imgs/whatsapp.png'
import instaIcon from '../imgs/insta.png'
import { BackButton } from "../UI/Buttons";
import "../css/global.scss"
import { usePage } from "../sanity/usePage";
import { urlFor } from "../sanity/imageUrl";
import Newsletter from "./Newsletter";


const Kontakt = () => {
    const { data } = usePage('kontakt')
    const facebookIconUrl = data?.contact?.facebookIcon ? urlFor(data.contact.facebookIcon) : fbIcon
    const whatsappIconUrl = data?.contact?.whatsappIcon ? urlFor(data.contact.whatsappIcon) : whatsappIcon
    const instagramIconUrl = data?.contact?.instagramIcon ? urlFor(data.contact.instagramIcon) : instaIcon
    const fbUrl = data?.contact?.facebookUrl || "https://www.facebook.com/profile.php?id=100095461966010&sfnsn=scwspwa";
    const instagramUrl = data?.contact?.instagramUrl || "https://www.instagram.com/biodanzaschule_freiburg/";
    const whatsappNumber = data?.contact?.whatsappNumber || "+491774347677";
    const contactHeading = data?.contact?.heading || "KONTAKT";
    const contactSubheading = data?.contact?.subheading || "Wir freuen uns auf deine Nachricht";
    const contactName = data?.contact?.name || "Beate Hoffmann";
    const contactEmail = data?.contact?.email || "info@biodanzaschule-freiburg.de";
    const contactPhone = data?.contact?.phone || "0177 43 47 677";

    const handleFacebookClick = () => {
        window.open(fbUrl, '_blank');
    };

    const handleWhatsappClick = () => {
        const wa = String(whatsappNumber || '').replace(/[^\d]/g, '')
        window.open(`https://wa.me/${wa}`, '_blank');
    };

    const handleInstagramClick = () => {
        window.open(instagramUrl, '_blank');
    };

    return (
        <>
            {/*    <div className="contact-bg ">*/}
            {/*</div>*/}

            <BackButton path={-1} />

            <div

            // style={{ minHeight: "80vh"}}
            >


                <div className="article-container-new">
                    <div className="article ">


                        <h2>
                            {contactHeading}
                        </h2>


                        <div className="w-100 center">
                            <h3 className="contact-subheading">{contactSubheading}</h3>
                        </div>

                        <div className="center contact-info">
                            {contactName}
                            <a className="contact-link" href={`mailto:${contactEmail}`}> {contactEmail}</a>
                            <a className="contact-link" href={`tel:${contactPhone.replace(/\s/g, '')}`}>{contactPhone}</a>
                        </div>

                        <p className="d-flex flex-row center icons">
                            <img src={facebookIconUrl} alt="Facebook" onClick={handleFacebookClick}
                                className="contact-icon contact-icon--facebook" />
                            <img src={whatsappIconUrl} alt="WhatsApp" onClick={handleWhatsappClick}
                                className="contact-icon" />
                            <img
                                src={instagramIconUrl}
                                alt="Instagram"
                                onClick={handleInstagramClick}
                                className="contact-icon contact-icon--instagram"
                            />

                        </p>



                    </div>

                </div> <div className="contact-newsletter">
                    <Newsletter />
                </div>
            </div>
        </>
    );
};

export default Kontakt;
